import React, { useState } from 'react';
import dayjs from 'utils/dayjs';

import Select from 'react-select';
import Toggle from 'react-toggle';
import { RangePicker } from 'components/DatePicker';
import Input from 'components/forms/Input';
import InputLabel from '../common/InputLabel';
import FormRow from './FormRow';
import TextArea from 'components/forms/Input/TextArea';
import { FormattedMessage } from 'react-intl';
import messages from '../../messages';

const options = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
];

const Proposals = ({ onInputChange, onDateRangeChange, onRoomNumberChange, formData, onToggleChange, currency }) => {
    const [wholeHouse, setWholeHouse] = useState(false);

    const changeRoomType = (event) => {
        if (!event.target.checked) {
            const resetValues = {
                value: 0,
            };
            onRoomNumberChange(resetValues);
        }
        setWholeHouse(event.target.checked);
    };

    return (
        <div>
            <FormRow>
                <InputLabel text={<FormattedMessage {...messages.groupName} />} />
                <Input
                    value={formData.groupName}
                    onChange={(event) => onInputChange('groupName', event.target.value)}
                    className="grpDisp-form-text"
                />
            </FormRow>
            <FormRow>
                <InputLabel text={<FormattedMessage {...messages.stayDatesLabel} />} />
                <RangePicker
                    onChange={onDateRangeChange}
                    style={{ height: '2.7em', width: '40%' }}
                    value={[dayjs(formData.startDate), dayjs(formData.endDate)]}
                />
            </FormRow>
            <FormRow
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    marginBottom: '1em',
                }}
            >
                <InputLabel text={<FormattedMessage {...messages.notes} />} />
                <TextArea
                    name="notes"
                    type="textarea"
                    rows={3}
                    onChange={(event) => onInputChange('notes', event.target.value)}
                    className="grpDisp-form-textarea"
                    value={formData.notes}
                />
            </FormRow>
            <FormRow>
                <InputLabel text={<FormattedMessage {...messages.budgetPRPNLabel} />} />
                <Input
                    value={formData.groupBudget}
                    onChange={(event) => onInputChange('groupBudget', event.target.value)}
                    className="grpDisp-form-number"
                    addonBefore={currency}
                />
            </FormRow>
            <FormRow style={{ display: 'flex', alignItems: 'center', minHeight: '2.7em' }}>
                <InputLabel
                    text={<FormattedMessage {...messages.washLabel} />}
                    tooltip={
                        <>
                            <FormattedMessage {...messages.washTipOne} /> <br />
                            <FormattedMessage {...messages.washTipTwo} />
                        </>
                    }
                />
                <Toggle
                    checked={formData.groupWash}
                    name="groupWash"
                    className="grpDisp-form-toggle"
                    onChange={onToggleChange}
                />
                {formData.groupWash && (
                    <>
                        <InputLabel text="Wash" style={{ width: '30%', paddingLeft: '2em' }} />
                        <Input
                            min="0"
                            type="number"
                            onChange={(event) => onInputChange('groupWashPercent', event.target.value)}
                            value={formData.groupWashPercent.toString()}
                            className="grpDisp-form-number"
                            addonAfter="%"
                        />
                    </>
                )}
            </FormRow>

            <FormRow style={{ display: 'flex', alignItems: 'center', minHeight: '2.7em' }}>
                <InputLabel
                    text="Is this group commissionable?"
                    tooltip={
                        <>
                            We will use this to help estimate the NETT value of the group to your business. <br />
                            Commission will only be deducted from room revenue unless applied in Section 3 below.
                        </>
                    }
                />
                <Toggle
                    checked={formData.groupCommission}
                    name="groupCommission"
                    className="grpDisp-form-toggle"
                    onChange={onToggleChange}
                />
                {formData.groupCommission && (
                    <>
                        <InputLabel text="Commission" style={{ width: '30%', paddingLeft: '2em' }} />
                        <Input
                            min="0"
                            type="number"
                            onChange={(event) => onInputChange('groupCommissionPercent', event.target.value)}
                            value={formData.groupCommissionPercent.toString()}
                            className="grpDisp-form-number"
                            addonAfter="%"
                        />
                    </>
                )}
            </FormRow>
            {false && (
                <FormRow>
                    <InputLabel text="Do you want to split this by room type?" />
                    <Toggle
                        name="wholeHouse"
                        checked={wholeHouse}
                        onChange={changeRoomType}
                        className="grpDisp-form-toggle"
                    />
                </FormRow>
            )}
            {wholeHouse && (
                <FormRow>
                    <InputLabel text="How many rooms would you like to include?" />
                    <Select
                        className="grpDisp-form-select"
                        name="numberOfRooms"
                        onChange={onRoomNumberChange}
                        options={options}
                    />
                </FormRow>
            )}
        </div>
    );
};

export default Proposals;
